<script lang="ts">
  import type { IApiPagination } from "../../utils/api/api-response";
  import type { ITableField } from "./table-field";
  import { createEventDispatcher } from "svelte";
  import Icon from "../Icon.svelte";
  import TableHeaderField from "./TableHeaderField.svelte";
  import TableDataField from "./TableDataField.svelte";
  import TablePaginator from "./TablePaginator.svelte";
  import ConfirmModal from "../Modal/ConfirmModal.svelte";

  export let klass: string = "";
  export let fields: ITableField<any>[];
  export let records: any[];
  export let loading: boolean = false;
  export let noElementsText: string = "non ci sono elementi da visualizzare";
  export let deletionRequestText: string =
    "Confermi la cancellazione dell'elemento selezionato?";
  export let createEnabled: boolean = false;
  export let editEnabled: boolean = false;
  export let customEnabled: boolean = false;
  export let customIcon: string = "launch" ; 
  export let showEnabled: boolean = false;
  export let deleteEnabled: boolean = false;
  export let exportEnabled: boolean = false;
  export let downloadEnabled: boolean = false;
  export let pagination: IApiPagination = null;

  let deleteModalOpen = false;
  let deletingRecord: any = null;

  const dispatch = createEventDispatcher();

  $: hasButtons =
    createEnabled  || showEnabled || editEnabled || deleteEnabled || exportEnabled || downloadEnabled;
  $: colspanValue = hasButtons ? fields.length + 1 : fields.length;
  $: numRecords = records != null ? records.length : 0;
  $: visibleFields = fields.filter((x) => !x.hidden);

  records.forEach(r => {
      r.selected = true;
    })

  function onSelect(record: any) {
    //record.selected = !record.selected;
    dispatch("select", [record]);
    dispatch("allupdate", records);
  }

  function onCreate() {
    dispatch("create");
  }

  function onEdit(record: any) {
    dispatch("edit", record);
  }

  function onCustom(record: any) {
    dispatch("custom", record);
  }

  function onDelete(record: any) {
    deletingRecord = record;
    deleteModalOpen = true;
  }

  function onDownload(record: any) {
    dispatch("download", record);
  }

  function confirmDelete() {
    if (!!deletingRecord) {
      let recordToDelete = Object.assign({}, deletingRecord);
      dispatch("delete", recordToDelete);
    }
    deletingRecord = null;
  }

  function declineDelete() {
    deletingRecord = null;
  }

  function onPageChange(event: CustomEvent<number>) {
    dispatch("pageChange", event.detail);
  }

  function onExport() {
    dispatch("export");
  }

  function toggleSelectAll() {
    let newvalue = !(records[0].selected);

    records.forEach(r => {
      r.selected = newvalue;
    })

    records = records;
    dispatch("allupdate", records);
  }


  function renderField(field: ITableField<any>, record: any) {
    if (field.render != null && typeof field.render === "function") {
      return field.render(record);
    }
    return record[field.name];
  }
</script>

<ConfirmModal
  title="Conferma cancellazione"
  message={deletionRequestText}
  bind:open={deleteModalOpen}
  on:confirm={confirmDelete}
  on:decline={declineDelete}
/>

<table class="table is-striped is-fullwidth table-base {klass}">
  <thead>
    <tr>
      {#if hasButtons}
        <TableHeaderField klass="table-buttons">
          {#if createEnabled}
            <Icon name="add" on:click={(_) => onCreate()} />
          {/if}
          {#if exportEnabled}
            <Icon name="file_download" on:click={(_) => onExport()} />
          {/if}
          <Icon name="check" on:click={(_) => toggleSelectAll()} />
          <i class="dummy-button" />
        </TableHeaderField>
      {/if}

      {#each visibleFields as field}
        <TableHeaderField
          klass={field.titleClass || ""}
          sortable={field.sortable}
        >
          {field.title}
        </TableHeaderField>
      {/each}
    </tr>
  </thead>

  <tbody>
    {#if loading == false}
      {#if numRecords == 0}
        <tr class="table-no-data">
          <td colspan={colspanValue}>
            {noElementsText}
          </td>
        </tr>
      {:else}
        {#each records as record}
          <tr>
            {#if true}
              <TableDataField klass="has-text-centered">
                <input
                  type="checkbox"
                  bind:checked={record.selected}
                  on:change={(_) => onSelect(record)}
                />
                {#if editEnabled}
                  <Icon name="edit" on:click={(_) => onEdit(record)} />
                {/if}
                {#if showEnabled}
                  <Icon name="search" on:click={(_) => onEdit(record)} />
                {/if}
                {#if deleteEnabled}
                  <Icon name="delete" on:click={(_) => onDelete(record)} />
                {/if}
                {#if downloadEnabled}
                  <Icon name="file_download" on:click={(_) => onDownload(record)} />
                {/if}
                {#if customEnabled}
                  <Icon name={customIcon} on:click={(_) => onCustom(record)} />
                {/if}
              </TableDataField>
            {/if}

            {#each visibleFields as field}
              <TableDataField klass={field.dataClass || ""}>
                {@html renderField(field, record)}
              </TableDataField>
            {/each}
          </tr>
        {/each}
      {/if}
    {:else}
      <tr class="table-no-data">
        <td colspan={colspanValue}>
          <div class="table-loader" />
        </td>
      </tr>
    {/if}
  </tbody>
</table>

{#if pagination != null}
  <TablePaginator {pagination} on:pageChange={onPageChange} />
{/if}

<style>
  .table-base {
    margin-top: 1.5rem;
  }

  .table-base tr.table-no-data {
    transition: all 1s linear;
  }

  .dummy-button {
    display: block;
    width: 0;
    height: 24px;
    float: left;
  }
</style>
